export default __webpack_public_path__ + "static/media/editingstyle.d6d30421.svg";